import React, { useState, Fragment, useEffect, useCallback, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import apiService from '../../services/apiServices';
import { departmentsForBranch } from '../../utils/departmentBranches';
import dateFormats, { ageFromBirthDate } from '../../services/dateFormats';
import validationSchema from '../../services/validationSchema';
import InputController from '../../controllers/InputController';
import PreferredEmailPicker from './PreferredEmailPicker';
import { yupResolver } from '@hookform/resolvers/yup';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '../actions/Modal';
import {
  Link,
  useParams,
  useHistory,
} from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import LinearProgress from '@mui/material/LinearProgress';
import config from '../../config/config';
import MuiSwitch from '@mui/material/Switch';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Avatar from '@mui/material/Avatar';


import HolidaysHistory from '../holidays/HolidaysHistory';
import WorkerProjectHistory from './WorkerProjectHistory';
import WorkerBankAccounts from './WorkerBankAccounts';
import WorkerProjectAssignmentForm from './WorkerProjectAssignmentForm';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import ShareIcon from '@mui/icons-material/Share';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import InputAdornment from '@mui/material/InputAdornment';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import GitHubIcon from '@mui/icons-material/GitHub';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';
import LanguageIcon from '@mui/icons-material/Language';
import LinkIcon from '@mui/icons-material/Link';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SvgIcon from '@mui/material/SvgIcon';
import { useTheme, alpha } from '@mui/material/styles';
import ModuleCustomFields from '../dynamic/ModuleCustomFields';
import useConfirm from '../../hooks/useConfirm';
import usePermissions from '../../hooks/usePermissions';
import ActivationDateHint from './ActivationDateHint';
import { accountStatus, accountStatusChip, formatDMY } from '../../utils/activationStatus';

// Kanalet dhe blloku vizual jetojnë te `AttendanceAccess` — një kopje për tërë
// aplikacionin. Ri-eksportimi këtu mban të pandryshuara importet ekzistuese
// (`from './EditWorker'`) që ekranet e tjera i kanë prej kohësh.
import AttendanceAccess, { ATTENDANCE_CHANNELS, normalizeChannels } from './AttendanceAccess';
// `export … from` nuk i sjell emrat në fushëveprim — dhe `normalizeChannels`
// përdoret edhe këtu, te parazgjedhjet e formës. Importi + ri-eksportimi i
// shprehur i mban të dyja: skedari e përdor, dhe ekranet e tjera e marrin prej tij.
export { ATTENDANCE_CHANNELS, normalizeChannels };

const SlackIcon = (props) => (
  <SvgIcon viewBox="0 0 122 122" {...props}>
    <path fill="#E01E5A" d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z" />
    <path fill="#36C5F0" d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z" />
    <path fill="#2EB67D" d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z" />
    <path fill="#ECB22E" d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z" />
  </SvgIcon>
);

export default function EditWorker(props) {
  const { t } = useTranslation();
  /**
   * Kanalet e prezencës i menaxhon WFM-ja, dhe vetëm ajo.
   *
   * Kjo është pasqyrimi i gardhit të serverit (`guardAttendanceFields`), jo
   * burimi i tij: një kërkesë e drejtpërdrejtë pa `attendance.manage` merr 403
   * edhe nëse dikush i heq këto atribute nga DOM-i. Kontrollet çkyçen në vend
   * që të fshihen — ashtu njeriu e sheh konfigurimin dhe e kupton pse s'e prek.
   */
  const { hasPermission } = usePermissions();
  const canManageAttendance = hasPermission('attendance.manage');
  const theme = useTheme();
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const [confirm, confirmUI] = useConfirm();
  const [contracts, setContracts] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modal, setModal] = useState({});
  const [rowId, setRowId] = useState({});
  const [loader, setLoader] = useState(true);
  const [loaderContracts, setLoaderContracts] = useState(true);
  const [workerConsents, setWorkerConsents] = useState([]);
  const [professionEdited, setProfessionEdited] = useState(false);
  // lookup lists for new fields
  const [allWorkers, setAllWorkers] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);
  const [allBranches, setAllBranches] = useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const [projectHistoryKey, setProjectHistoryKey] = useState(0);
  const [socialNetworks, setSocialNetworks] = useState([]);
  const [insMembers, setInsMembers] = useState([]);
  const [capAlert, setCapAlert] = useState({ open: false, available: 0, over: 0 });

  // Custom fields managed via ModuleCustomFields (self-contained, saves via ref)
  const cfRef = useRef();
  const [customValues, setCustomValues] = useState({});
  // Tri tab-et — e njëjta ndarje si te RegisterWorker.
  const [tab, setTab] = useState(0);
  // Llogaria e lidhur me këtë punëtor (FK ose email): `undefined` = po kërkohet,
  // `null` = s'ka. Vetëm lexim — llogaria menaxhohet te /user-management.
  const [linkedAccount, setLinkedAccount] = useState(undefined);
  const history = useHistory();

  // Insured family members (same fields as the primary insured + relationship).
  const addInsMember = () => setInsMembers((prev) => [...prev, { cardNumber: '', name: '', relation: '', startDate: '', endDate: '', amount: '' }]);
  const removeInsMember = (idx) => setInsMembers((prev) => prev.filter((_, i) => i !== idx));
  const updateInsMember = (idx, field, val) =>
    setInsMembers((prev) => prev.map((m, i) => (i === idx ? { ...m, [field]: val } : m)));

  const socialPlatforms = useMemo(() => ([
    { id: 'slack',     labelKey: 'worker.socialSlack',     Icon: SlackIcon,     color: '#4A154B', placeholder: '@username · workspace.slack.com', notify: true },
    { id: 'whatsapp',  labelKey: 'worker.socialWhatsapp',  Icon: WhatsAppIcon,  color: '#25D366', placeholder: '+383 44 …', notify: true },
    { id: 'telegram',  labelKey: 'worker.socialTelegram',  Icon: TelegramIcon,  color: '#229ED9', placeholder: '@username', notify: true },
    { id: 'linkedin',  labelKey: 'worker.socialLinkedin',  Icon: LinkedInIcon,  color: '#0A66C2', placeholder: 'linkedin.com/in/…' },
    { id: 'facebook',  labelKey: 'worker.socialFacebook',  Icon: FacebookIcon,  color: '#1877F2', placeholder: 'facebook.com/…' },
    { id: 'instagram', labelKey: 'worker.socialInstagram', Icon: InstagramIcon, color: '#E4405F', placeholder: '@username' },
    { id: 'twitter',   labelKey: 'worker.socialTwitter',   Icon: TwitterIcon,   color: '#1DA1F2', placeholder: '@username' },
    { id: 'github',    labelKey: 'worker.socialGithub',    Icon: GitHubIcon,    color: '#24292F', placeholder: 'github.com/…' },
    { id: 'website',   labelKey: 'worker.socialWebsite',   Icon: LanguageIcon,  color: '#64748B', placeholder: 'https://…' },
    { id: 'other',     labelKey: 'worker.socialOther',     Icon: LinkIcon,      color: '#94A3B8', placeholder: 'https://…' },
  ]), []);

  const addSocialNetwork = () => {
    const used = new Set(socialNetworks.map((s) => s.platform));
    const next = socialPlatforms.find((p) => !used.has(p.id)) || socialPlatforms[0];
    setSocialNetworks((prev) => [...prev, { platform: next.id, value: '' }]);
  };
  const removeSocialNetwork = (idx) => {
    setSocialNetworks((prev) => prev.filter((_, i) => i !== idx));
  };
  const updateSocialNetwork = (idx, field, val) => {
    setSocialNetworks((prev) => prev.map((s, i) => (i === idx ? { ...s, [field]: val } : s)));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    control,
    watch,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(validationSchema),

  });
  let { id } = useParams();

  const toYMD = (value) => {
    if (!value) return '';
    const asString = String(value).trim();
    const pad = (v) => ('0' + v).slice(-2);
    const fromParts = (yy, mm, dd) => {
      if (!yy || !mm || !dd) return '';
      return `${yy}-${pad(mm)}-${pad(dd)}`;
    };
    if (asString.includes('.')) {
      const parts = asString.split('.');
      if (parts.length >= 3) {
        const [d, m, y] = parts;
        return fromParts(y, m, d);
      }
    }
    if (asString.includes('-')) {
      const [dateOnly] = asString.split('T');
      const parts = dateOnly.split('-');
      if (parts.length >= 3) {
        const [y, m, d] = parts;
        return fromParts(y, m, d);
      }
    }
    const parsed = new Date(asString);
    if (!isNaN(parsed)) {
      return fromParts(parsed.getFullYear(), parsed.getMonth() + 1, parsed.getDate());
    }
    return '';
  };

  const getContracts = useCallback(() => {
    if (!id) return;
    apiService()
      .query('getWorkerContracts', 'id=' + id)
      .then((wc) => {
        if (wc.success) {
          setContracts(wc.data)
        } else {
          console.error('Error:', wc.errorMessage);
        }
      })
      .catch((err) => {
        console.error('[getContracts] failed', err);
      })
      .finally(() => {
        setLoaderContracts(false)
      });
  }, [id]);

  useEffect(() => {
    if (!id) {
      setLoader(false);
      setToast({
        open: true,
        message: t('worker.workerIdMissing'),
        variant: 'error',
      });
      return;
    }

    const normalizeGender = (g) => {
      if (g === null || g === undefined) return '';
      const s = String(g).trim().toUpperCase();
      if (s === 'M' || s === 'MASHKULL' || s === 'MALE') return '1';
      if (s === 'F' || s === 'FEMËR' || s === 'FEMER' || s === 'FEMALE') return '0';
      return String(g);
    };

    const normalizeWorker = (w) => ({
      ...w,
      Id: w?.Id ?? w?.id,
      EmployeeCode: w?.EmployeeCode ?? w?.employee_code,
      PersonalId: w?.PersonalId ?? w?.personal_id ?? w?.PersonalNumber ?? w?.personalNumber ?? w?.personal_number,
      FirstName: w?.FirstName ?? w?.first_name ?? w?.firstname ?? w?.firstName,
      ParentName: w?.ParentName ?? w?.parent_name ?? w?.parentName,
      LastName: w?.LastName ?? w?.last_name ?? w?.lastname ?? w?.lastName,
      Birthday: w?.Birthday ?? w?.birthday ?? w?.DateOfBirth ?? w?.dateOfBirth ?? w?.date_of_birth,
      Gender: normalizeGender(w?.Gender ?? w?.gender),
      MaritalStatus: w?.MaritalStatus ?? w?.marital_status ?? w?.maritalStatus,
      Email: w?.Email ?? w?.email,
      WorkEmail: w?.WorkEmail ?? w?.work_email ?? '',
      PreferredEmail: (w?.PreferredEmail ?? w?.preferred_email) === 'work' ? 'work' : 'personal',
      Phone: w?.Phone ?? w?.phone,
      Qualification: w?.Qualification ?? w?.qualification,
      Address: w?.Address ?? w?.address,
      PostalCode: w?.PostalCode ?? w?.postal_code ?? w?.postalCode,
      Country: w?.Country ?? w?.country,
      Place: w?.Place ?? w?.place,
      BankName: w?.BankName ?? w?.bank_name,
      BankAccount: w?.BankAccount ?? w?.bank_account,
      SecondJob: (w?.SecondJob ?? w?.second_job) === true,
      Residency: (w?.Residency ?? w?.residency) || 'resident',
      SalaryType: (w?.SalaryType ?? w?.salary_type) === 'net' ? 'net' : 'gross',
      Image: w?.Image ?? w?.image,
      StartDate: w?.StartDate ?? w?.start_date ?? w?.startDate ?? w?.HireDate ?? w?.hireDate ?? w?.hire_date,
      EndDate: w?.EndDate ?? w?.end_date ?? w?.endDate,
      WorkType: w?.WorkType ?? w?.work_type ?? w?.workType,
      Department: w?.Department ?? w?.department,
      SalaryType: w?.SalaryType ?? w?.salary_type ?? w?.salaryType,
      BaseSalary: w?.BaseSalary ?? w?.base_salary ?? w?.baseSalary,
      HourSalary: w?.HourSalary ?? w?.hour_salary ?? w?.hourSalary,
      HourSalaryWeekend: w?.HourSalaryWeekend ?? w?.hour_salary_weekend ?? w?.hourSalaryWeekend,
      HourSalaryHoliday: w?.HourSalaryHoliday ?? w?.hour_salary_holiday ?? w?.hourSalaryHoliday,
      BrutoNeto: w?.BrutoNeto ?? w?.bruto_neto ?? w?.brutoNeto,
      EmployeeTax: w?.EmployeeTax ?? w?.employee_tax ?? w?.employeeTax,
      EmployerTax: w?.EmployerTax ?? w?.employer_tax ?? w?.employerTax,
      WithTax: w?.WithTax ?? w?.with_tax ?? w?.withTax,
      ContractExtension: w?.ContractExtension ?? w?.contract_extension ?? w?.contractExtension,
      Template: w?.Template ?? w?.template,
      SupervisorId: w?.SupervisorId ?? w?.supervisor_id ?? null,
      EmploymentEndDate: w?.EmploymentEndDate ?? w?.employment_end_date ?? '',
      // Data e aktivizimit (workers.activation_date): llogaria hyn vetëm nga ajo ditë.
      ActivationDate:    w?.ActivationDate    ?? w?.activation_date    ?? '',
      SeparationType:    w?.SeparationType    ?? w?.separation_type    ?? '',
      SeparationReason:  w?.SeparationReason  ?? w?.separation_reason  ?? '',
      DepartmentIds:     w?.DepartmentIds     ?? w?.department_ids     ?? [],
      Branch:            w?.Branch ?? w?.branch_id ?? null,
      ProjectIds:        w?.ProjectIds        ?? w?.project_ids        ?? [],
      ATKRegistered: w?.ATKRegistered ?? w?.atk_registered ?? w?.atkRegistered,
      ATKRegisteredAt: w?.ATKRegisteredAt ?? w?.atk_registered_at ?? w?.atkRegisteredAt,
      WorkPermitNumber:  w?.WorkPermitNumber  ?? w?.work_permit_number  ?? '',
      WorkPermitIssued:  w?.WorkPermitIssued  ?? w?.work_permit_issued  ?? '',
      WorkPermitExpires: w?.WorkPermitExpires ?? w?.work_permit_expires ?? '',
      HealthInsPersonal: w?.HealthInsPersonal ?? w?.health_ins_personal ?? 0,
      HealthInsFamily:   w?.HealthInsFamily   ?? w?.health_ins_family   ?? 0,
      HealthInsNumber:   w?.HealthInsNumber   ?? w?.health_ins_number   ?? '',
      HealthInsHolderName: w?.HealthInsHolderName ?? w?.health_ins_holder_name ?? '',
      HealthInsTotal:    w?.HealthInsTotal    ?? w?.health_ins_total    ?? 0,
      HealthInsMembers:  w?.HealthInsMembers  ?? w?.health_ins_members  ?? [],
      HealthInsIssued:   w?.HealthInsIssued   ?? w?.health_ins_issued   ?? '',
      HealthInsExpires:  w?.HealthInsExpires  ?? w?.health_ins_expires  ?? '',
      HasTimeTracker:    (w?.HasTimeTracker ?? w?.has_time_tracker) !== false,
      // Mungesa lexohet si "lejohet": një bazë e pamigruar s'duhet t'ua mbyllë
      // punën të gjithëve sapo hapet forma.
      KioskScanAllowed:  (w?.KioskScanAllowed ?? w?.kiosk_scan_allowed) !== false,
      KioskScanNote:     w?.KioskScanNote ?? w?.kiosk_scan_note ?? '',
      // Regjistrimi i prezencës. `null` te kanalet do të thotë "ndiq
      // parazgjedhjen e kompanisë" — ndryshe nga `[]`, që do të thoshte
      // "asnjë kanal". Të dyja ruhen; mos i bashko.
      AttendanceEnabled:  (w?.AttendanceEnabled ?? w?.attendance_enabled) !== false,
      AttendanceChannels: normalizeChannels(w?.AttendanceChannels ?? w?.attendance_channels),
    });

    // load lookup lists in parallel
    const loadLists = async () => {
      try {
        const [wRes, dRes, pRes, bRes] = await Promise.all([
          apiService().get('workers'),
          apiService().get('department'),
          apiService().get('projects'),
          apiService().get('branches'),
        ]);
        if (bRes?.success)  setAllBranches((bRes.data || []).filter((b) => b.Active !== false));
        if (wRes?.success)  setAllWorkers((wRes.data  || []).filter(w => String(w.Id || w.id) !== String(id)));
        if (dRes?.success)  setAllDepartments(dRes.data  || []);
        if (pRes?.success)  setAllProjects(pRes.data    || []);
      } catch (err) { console.error('Failed to load lookup lists', err); }
    };
    loadLists();

    const loadWorker = async () => {
      const shapeRow = (raw) => {
        if (!raw) return null;
        const r = Array.isArray(raw) ? raw[0] : raw;
        return r ? normalizeWorker(r) : null;
      };

      let row = null;
      try {
        const response = await apiService().query('getWorker', 'id=' + id);
        if (response?.success) row = shapeRow(response.data);
        // Fallback to /workers/:id if the query returns nothing
        if (!row) {
          const fallback = await apiService().getById('workers', id);
          if (fallback?.success) row = shapeRow(fallback.data);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to load worker', err);
      }

      if (row) {
        const hydrated = {
          ...row,
          Birthday: toYMD(row.Birthday),
          StartDate: toYMD(row.StartDate),
          EmploymentEndDate: toYMD(row.EmploymentEndDate),
          ActivationDate: toYMD(row.ActivationDate),
          EndDate: toYMD(row.EndDate),
          ATKRegisteredAt: toYMD(row.ATKRegisteredAt),
          WorkPermitIssued:  toYMD(row.WorkPermitIssued),
          WorkPermitExpires: toYMD(row.WorkPermitExpires),
        };

        reset(hydrated);
        // Hydrate social networks list (column is JSONB; backend may return array or string)
        try {
          const raw = row.SocialNetworks;
          let arr = [];
          if (Array.isArray(raw)) arr = raw;
          else if (typeof raw === 'string' && raw.trim()) {
            try { const p = JSON.parse(raw); if (Array.isArray(p)) arr = p; } catch {}
          }
          setSocialNetworks(
            arr
              .filter((s) => s && (s.platform || s.value))
              .map((s) => ({ platform: String(s.platform || 'other'), value: String(s.value || '') }))
          );
        } catch (_) { /* noop */ }
        // Hydrate insured family members (JSONB; may be array or string)
        try {
          const raw = row.HealthInsMembers;
          let arr = [];
          if (Array.isArray(raw)) arr = raw;
          else if (typeof raw === 'string' && raw.trim()) {
            try { const p = JSON.parse(raw); if (Array.isArray(p)) arr = p; } catch {}
          }
          setInsMembers(arr.map((m) => ({
            cardNumber: String(m?.cardNumber || ''),
            name: String(m?.name || ''),
            relation: String(m?.relation || ''),
            startDate: String(m?.startDate || m?.birthday || ''),
            endDate: String(m?.endDate || ''),
            amount: m?.amount ?? '',
          })));
        } catch (_) { /* noop */ }
        // Auto-suggest profession on first load if missing
        try {
          const loaded = row || {};
          if ((!loaded.Profession || loaded.Profession === '') && loaded.Qualification) {
            const s = suggestProfession(loaded.Qualification);
            if (s) setValue('Profession', s);
          }
        } catch (e) { /* noop */ }

        getContracts();
        // Llogaria e lidhur: nga /api/users (vetëm admin/menaxher; 403 → «pa të dhëna»,
        // jo gabim). Lidhja është FK ose email, si te hyrja.
        (async () => {
          try {
            const ur = await apiService().get('users');
            const list = Array.isArray(ur?.data) ? ur.data : [];
            const email = String(row.Email || '').trim().toLowerCase();
            const hit = list.find((u) => String(u.worker_id || '') === String(id))
              || (email ? list.find((u) => !u.worker_id && String(u.email || '').toLowerCase() === email) : null);
            setLinkedAccount(hit ? {
              id: hit.id, email: hit.email, role: hit.role, active: hit.active,
              activationDate: hit.activation_date || null,
              activationStatus: hit.activation_status || null,
              inviteDueAt: hit.invite_due_at || null,
              inviteSentAt: hit.invite_sent_at || null,
            } : null);
          } catch (_) { setLinkedAccount(null); }
        })();
        // Fetch termination consents for this worker — vetëm për role HR/admin/menaxher
        (async () => {
          try {
            // Lexo rolet aktuale; nëse user-i s'ka rol HR, anashkalo thirrjen (backend kthen 403)
            const readUser = () => {
              const stores = [
                () => sessionStorage.getItem('logedInUser'),
                () => localStorage.getItem('logedInUser'),
                () => { const m = document.cookie.match(/(?:^|;\s*)logedInUser=([^;]*)/); return m ? decodeURIComponent(m[1]) : null; },
              ];
              for (const s of stores) {
                try { const v = s(); if (v) return JSON.parse(v); } catch {}
              }
              return null;
            };
            const u = readUser();
            const roles = (u?.data?.roles || u?.roles || []).map(r => String(r?.name || r?.role_name || r || '').toLowerCase());
            const canSeeConsents = roles.some(r => ['admin','hr','menaxher','manager','superadmin','super_admin','company_admin','hr_manager'].includes(r));
            if (!canSeeConsents) return;
            const tok = u?.token || u?.data?.token || '';
            if (!tok) return;
            const apiUrl = process.env.REACT_APP_API_URL || '';
            const r = await fetch(`${apiUrl}/api/termination-consents`, {
              headers: { Authorization: `Bearer ${tok}` },
            }).then(x => x.json()).catch(() => null);
            if (r?.success && Array.isArray(r.data)) {
              setWorkerConsents(r.data.filter(c => String(c.workerId) === String(id)));
            }
          } catch (_) {}
        })();
        setLoader(false);
        return;
      }

      setLoader(false);
      setLoaderContracts(false);
      setToast({
        open: true,
        message: t('worker.workerNotFound'),
        variant: 'error',
      });
    };

    loadWorker();
  }, [getContracts, id, reset, setValue]);

  const suggestProfession = (q) => {
    const val = String(q || '').toLowerCase();
    if (!val) return '';
    if (val.includes('matemat')) return 'Matematikan';
    if (val.includes('informatik')) return 'Programer / Inxhinier Softueri';
    if (val.includes('ekonom')) return 'Ekonomist';
    if (val.includes('jurid')) return 'Jurist';
    return '';
  };

  const openModal = (id) => {
    setModal({
      open: true,
      tittle: 'Delete',
      message: 'Do you want to delete this row?',
    });
    setToast({ open: false });
    setRowId(id);
  };

  const handleDelete = (id) => {
    apiService()
      .delete('workerContract', id)
      .then((response) => {
        if (response) {
          setModal({ open: false });
          setToast({
            open: true,
            message: 'U fshi me sukses!',
            variant: 'success',
          });
          getContracts()
          //setWorkers(workers.filter((worker) => worker.Id !== id));
        } else {
          setModal({ open: false });
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  const onSubmit = (data) => {
    const normalizeDateForPayload = (v) => {
      if (!v) return null;
      const asString = String(v).trim();
      const formatYMD = (dateString) => {
        if (!dateString) return null;
        const [y, m, d] = dateString.split('-');
        if (y && m && d) {
          return `${y}-${('0' + m).slice(-2)}-${('0' + d).slice(-2)}`;
        }
        return null;
      };
      // Accept dd.mm.yyyy
      if (asString.includes('.')) {
        const [d, m, y] = asString.split('.');
        if (y && m && d) return `${y}-${('0' + m).slice(-2)}-${('0' + d).slice(-2)}`;
      }
      // Accept yyyy-mm-dd or ISO strings
      if (asString.includes('-')) {
        const [dateOnly] = asString.split('T');
        const fmt = formatYMD(dateOnly);
        if (fmt) return fmt;
      }
      const dt = new Date(asString);
      if (!isNaN(dt)) {
        const y = dt.getFullYear();
        const m = ('0' + (dt.getMonth() + 1)).slice(-2);
        const d = ('0' + dt.getDate()).slice(-2);
        return `${y}-${m}-${d}`;
      }
      return null;
    };

    const payload = {
      ...data,
      Id: data?.Id ?? id,
      Birthday: normalizeDateForPayload(data.Birthday),
      StartDate: normalizeDateForPayload(data.StartDate),
      EmploymentEndDate: normalizeDateForPayload(data.EmploymentEndDate),
      ActivationDate: normalizeDateForPayload(data.ActivationDate),
      EndDate: normalizeDateForPayload(data.EndDate),
      ATKRegisteredAt: normalizeDateForPayload(data.ATKRegisteredAt),
      WorkPermitIssued:  normalizeDateForPayload(data.WorkPermitIssued),
      WorkPermitExpires: normalizeDateForPayload(data.WorkPermitExpires),
    };

    // Backend tabela workers ka fushat atk_registered dhe atk_registered_at
    // Profession nuk ka kolonë — e heqim që të mos bjerë 400.
    delete payload.Profession;
    // Normalize array fields for backend
    if (!Array.isArray(payload.DepartmentIds)) payload.DepartmentIds = [];
    if (!Array.isArray(payload.ProjectIds))    payload.ProjectIds    = [];
    payload.DepartmentIds = payload.DepartmentIds.filter(Boolean).map(Number);
    payload.ProjectIds    = payload.ProjectIds.filter(Boolean).map(Number);
    const cleanedSocial = socialNetworks
      .map((s) => ({ platform: s.platform, value: String(s.value || '').trim() }))
      .filter((s) => s.value);
    payload.SocialNetworks = cleanedSocial.length ? JSON.stringify(cleanedSocial) : null;
    // Insured family members + auto-computed family total.
    const filledMembers = insMembers.filter((m) => String(m.name || '').trim());
    payload.HealthInsMembers = filledMembers.length ? JSON.stringify(filledMembers) : null;
    payload.HealthInsFamily = insMembers.reduce((s, m) => s + (Number(m.amount) || 0), 0) || 0;
    // data.WorkType = data.WorkType.id;
    // data.SalaryType = data.SalaryType.id;
    // data.Department = data.Department.id;
    // data.BranchId = data.BranchId.id;
    apiService()
      .put('workers', payload, payload.Id)
      .then(async (response) => {
        if (response.success) {
          // Save custom field values
          await cfRef.current?.saveValues(customValues);
          setToast({
            open: true,
            message: 'U ruajten me sukses!',
            variant: 'success',
          });
        } else {
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  const setImage = (e) => {
    if (e) {
      let file = e.target.files[0]
      var reader = new FileReader()
      let src = ''
      reader.onloadend = function () {
        var data = reader.result.split(',')[1]
        src = 'data:image/png;base64,' + data
        setValue('Image', src)
      }
      reader.readAsDataURL(file)
    }
  }
  // Insurance budget split across primary insured (worker) + family members,
  // capped so allocations never exceed the total.
  const insTotal = Number(watch('HealthInsTotal')) || 0;
  const insMainAmount = Number(watch('HealthInsPersonal')) || 0;
  const insMembersTotal = insMembers.reduce((s, m) => s + (Number(m.amount) || 0), 0);
  const insAllocated = insMainAmount + insMembersTotal;
  const insRemaining = insTotal > 0 ? Math.max(0, insTotal - insAllocated) : 0;
  const insOver = insTotal > 0 && insAllocated > insTotal + 0.001;
  const insBase = insTotal > 0 ? insTotal : insAllocated;
  const insPct = (x) => (insBase > 0 ? Math.round(((Number(x) || 0) / insBase) * 1000) / 10 : 0);
  const insMaxFor = (excludeMemberIdx, excludePrimary) => {
    if (insTotal <= 0) return Infinity;
    const others = (excludePrimary ? 0 : insMainAmount)
      + insMembers.reduce((s, m, i) => (i === excludeMemberIdx ? s : s + (Number(m.amount) || 0)), 0);
    return Math.max(0, insTotal - others);
  };
  const notifyOverCap = (available, over) => setCapAlert({ open: true, available, over });
  // Keep the raw typed string so amounts type naturally; clamp only when over.
  const setPrimaryAmount = (raw) => {
    const max = insMaxFor(-1, true);
    const n = Number(raw);
    if (Number.isFinite(n) && n > max) {
      notifyOverCap(max, n - max);
      setValue('HealthInsPersonal', max);
    }
  };
  const setMemberAmount = (idx, raw) => {
    const max = insMaxFor(idx, false);
    const n = Number(raw);
    if (Number.isFinite(n) && n > max) {
      notifyOverCap(max, n - max);
      updateInsMember(idx, 'amount', String(max));
    } else {
      updateInsMember(idx, 'amount', raw);
    }
  };

  // ── Ndarja vizuale: e njëjta si te regjistrimi (RegisterWorker) ─────────────
  // Tri tab-e, seksione me ngjyrë të vetën. Të njëjtat helper-ë, që dy ekranet
  // të mos rrëshqasin nga njëri-tjetri herën tjetër që dikush prek njërin.
  const sectionSx = (color) => ({
    mb: 1.25, p: { xs: 1.25, sm: 1.5 }, borderRadius: 2,
    bgcolor: alpha(color, 0.04), border: '1px solid', borderColor: alpha(color, 0.18),
  });
  const sectionTitleSx = (color) => ({
    fontWeight: 700, fontSize: { xs: '0.8125rem', md: '0.875rem' }, mb: 1,
    display: 'flex', alignItems: 'center', gap: 0.6, color,
  });
  // Validimi jeton te tab-i «Bazike»; nëse «Ruaj» shtypet nga tab tjetër me
  // fusha të pavlefshme, kthehu aty që gabimi të shihet.
  const onInvalid = (errs) => {
    if (errs.FirstName || errs.LastName || errs.Email || errs.PersonalId) setTab(0);
  };
  const submit = handleSubmit(onSubmit, onInvalid);
  const fullName = `${watch('FirstName') || ''} ${watch('LastName') || ''}`.trim();
  const expiryChip = (dateValue) => {
    if (!dateValue) return null;
    const exp = new Date(dateValue);
    const now = new Date();
    const daysLeft = Math.ceil((exp - now) / 86400000);
    if (daysLeft < 0)  return <Chip size="small" label={t('worker.expired')} sx={{ height: 20, fontSize: '0.68rem', bgcolor: '#FEE2E2', color: '#991B1B', fontWeight: 700, borderRadius: 1 }} />;
    if (daysLeft < 30) return <Chip size="small" label={t('worker.expiresInDays', { count: daysLeft })} sx={{ height: 20, fontSize: '0.68rem', bgcolor: '#FEF9C3', color: '#92400E', fontWeight: 700, borderRadius: 1 }} />;
    return <Chip size="small" icon={<VerifiedOutlinedIcon sx={{ fontSize: 14 }} />} label={t('worker.valid')} sx={{ height: 20, fontSize: '0.68rem', bgcolor: '#DCFCE7', color: '#166534', fontWeight: 700, borderRadius: 1, '& .MuiChip-icon': { color: '#166534', ml: 0.5 } }} />;
  };
  const todayYMD = () => {
    const d = new Date();
    return `${d.getFullYear()}-${('0' + (d.getMonth() + 1)).slice(-2)}-${('0' + d.getDate()).slice(-2)}`;
  };

  return (
    <Box sx={{ bgcolor: '#f8f9fc', minHeight: '100vh', py: { xs: 0.5, md: 0.75 }, px: { xs: 1, sm: 1.5, md: 2 } }}>
      <Fragment>
        <Modal {...modal} handleDelete={() => handleDelete(rowId)} />
        {confirmUI}
        <Toast {...toast} />
        <Snackbar
          open={capAlert.open}
          autoHideDuration={4500}
          onClose={() => setCapAlert((a) => ({ ...a, open: false }))}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          sx={{ mt: { xs: 8, sm: 9 } }}
        >
          <Paper
            elevation={8}
            sx={{
              display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.25,
              borderRadius: 2.5, maxWidth: 500,
              border: '1px solid', borderColor: alpha(theme.palette.warning.main, 0.4),
              borderLeft: `4px solid ${theme.palette.warning.main}`,
              boxShadow: '0 12px 32px rgba(0,0,0,0.16)',
            }}
          >
            <Box sx={{ width: 38, height: 38, borderRadius: '50%', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: alpha(theme.palette.warning.main, 0.16) }}>
              <WarningAmberRoundedIcon sx={{ color: theme.palette.warning.dark, fontSize: 22 }} />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontWeight: 700, fontSize: '0.9rem', lineHeight: 1.3 }}>
                Shuma u kufizua në maksimumin e lejuar
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', lineHeight: 1.4 }}>
                Lejohet deri në <Box component="span" sx={{ fontWeight: 800, color: 'warning.dark' }}>{capAlert.available.toFixed(2)} €</Box> për këtë fushë · nga {insTotal.toFixed(2)} € total.
              </Typography>
            </Box>
            <IconButton size="small" onClick={() => setCapAlert((a) => ({ ...a, open: false }))} sx={{ ml: 0.5, color: 'text.secondary' }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Paper>
        </Snackbar>

        <form onSubmit={(e) => e.preventDefault()}>
          <Paper sx={{ p: { xs: 1.25, sm: 1.5, md: 1.75 }, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}>
            {/* Header — compact single row with inline actions (si te regjistrimi) */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.25, pb: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
              <Box sx={{ position: 'relative', flexShrink: 0 }}>
                <Avatar src={watch('Image') || config.avatar} sx={{ width: 40, height: 40, border: `2px solid ${alpha(theme.palette.primary.main, 0.15)}` }}>
                  <PersonIcon sx={{ fontSize: 22 }} />
                </Avatar>
                <input accept="image/*" style={{ display: 'none' }} id="imageUpload" type="file" onChange={(e) => setImage(e)} />
                <label htmlFor="imageUpload">
                  <IconButton component="span" size="small" sx={{ position: 'absolute', bottom: -4, right: -4, bgcolor: 'primary.main', color: 'white', '&:hover': { bgcolor: 'primary.dark' }, width: 18, height: 18 }}>
                    <PhotoCameraIcon sx={{ fontSize: 11 }} />
                  </IconButton>
                </label>
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontWeight: 700, fontSize: { xs: '0.9rem', md: '1rem' }, lineHeight: 1.2 }} noWrap>
                  {t('worker.personalDataTitle')}{fullName ? ` — ${fullName}` : ''}
                </Typography>
                <Typography variant="caption" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' }, lineHeight: 1.3 }}>
                  {watch('EmployeeCode') ? `${watch('EmployeeCode')} · ` : ''}Të njëjtat ndarje si te regjistrimi: bazike · punësimi & kontrata · dokumente & qasje.
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
                <Button size="small" variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => history.goBack()} sx={{ textTransform: 'none' }}>
                  Kthehu
                </Button>
                <Button size="small" variant="contained" color="success" startIcon={<SaveIcon />} disabled={loader} onClick={submit} sx={{ textTransform: 'none' }}>
                  Ruaj
                </Button>
              </Box>
            </Box>

            {loader && <LinearProgress sx={{ my: 4 }} />}
            {!loader && <>
              {(() => {
                try {
                  const now = new Date();
                  // Build "tomorrow" via a real Date so month/year roll over correctly
                  // (e.g. the 31st → next month's 1st instead of an invalid day).
                  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
                  const y = d.getFullYear();
                  const m = ('0' + (d.getMonth() + 1)).slice(-2);
                  const da = ('0' + d.getDate()).slice(-2);
                  const tmw = `${y}-${m}-${da}`;
                  return watch('StartDate') === tmw ? (
                    <Alert severity="warning" sx={{ mb: 1.5 }}>
                      {t('worker.urgentATKAlert')}
                    </Alert>
                  ) : null;
                } catch (_) { return null; }
              })()}
              <input type="hidden" {...register('Id')} />

              {/* Tabs */}
              <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 1.25 }}>
                <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile
                  sx={{ minHeight: 38, '& .MuiTab-root': { minHeight: 38, py: 0.5 } }}>
                  <Tab label="Të dhëna bazike" sx={{ textTransform: 'none', fontWeight: 600 }} />
                  <Tab label="Punësimi & Kontrata" sx={{ textTransform: 'none', fontWeight: 600 }} />
                  <Tab label="Dokumente & Qasje" sx={{ textTransform: 'none', fontWeight: 600 }} />
                </Tabs>
              </Box>

              {/* ── Tab 0: Të dhëna bazike ─────────────────────────────────────── */}
              <Box sx={{ display: tab === 0 ? 'block' : 'none' }}>
              {/* Personal */}
              <Box sx={sectionSx(theme.palette.primary.main)}>
                <Typography variant="subtitle2" sx={sectionTitleSx('primary.main')}>
                  <PersonIcon sx={{ fontSize: 18 }} /> Të dhëna personale
                </Typography>
                <Grid container spacing={{ xs: 1, sm: 1.5 }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <InputController
                      placeholder="Kodi i punëtorit (ID)"
                      control={control}
                      register={{ ...register('EmployeeCode') }}
                      name="EmployeeCode"
                      rules={{ required: false }}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <InputController
                      placeholder="Numri Personal / Pasaporta"
                      error={errors.PersonalId}
                      control={control}
                      register={{ ...register('PersonalId') }}
                      name="PersonalId"
                      type="number"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <InputController placeholder="Emri" error={errors.FirstName} control={control} register={{ ...register('FirstName') }} name="FirstName" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <InputController placeholder="Mbiemri" error={errors.LastName} control={control} register={{ ...register('LastName') }} name="LastName" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <InputController placeholder="Emri i prindit" error={errors.ParentName} control={control} register={{ ...register('ParentName') }} name="ParentName" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    {/* Mosha rri brenda vetë fushës dhe ndryshon ndërsa shkruan:
                        këtu ajo nuk është vetëm informacion, po edhe kontroll —
                        një vit i shtypur gabim (1090, 2990) del menjëherë si
                        moshë që nuk shkruhet fare. */}
                    <InputController
                      placeholder="Datelindja"
                      error={errors.Birthday}
                      control={control}
                      type="date"
                      register={{ ...register('Birthday') }}
                      name="Birthday"
                      symbol={(() => {
                        const a = ageFromBirthDate(watch('Birthday'));
                        return a === null ? null : (
                          <Box component="span" sx={{ fontSize: '0.75rem', color: 'text.secondary', whiteSpace: 'nowrap' }}>
                            {a} vjeç
                          </Box>
                        );
                      })()}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <InputController
                      placeholder="Kualifikimi"
                      error={errors.Qualification}
                      control={control}
                      register={{ ...register('Qualification') }}
                      name="Qualification"
                      changeHandler={(e) => {
                        const currentProf = watch('Profession');
                        if (!currentProf || !professionEdited) {
                          const s = suggestProfession(e?.target?.value);
                          if (s) setValue('Profession', s);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <InputController
                      placeholder="Profesioni (propozohet nga shkollimi)"
                      error={errors.Profession}
                      control={control}
                      register={{ ...register('Profession') }}
                      name="Profession"
                      onFieldChange={() => setProfessionEdited(true)}
                    />
                  </Grid>
                  <Grid item xs={6} sm={3} md={3}>
                    <Controller
                      render={({ field }) => (
                        <RadioGroup row aria-label="gender" {...field} value={String(watch('Gender') ?? '')}>
                          <FormControlLabel value="0" control={<Radio size="small" />} label={t('worker.female')} />
                          <FormControlLabel value="1" control={<Radio size="small" />} label={t('worker.male')} />
                        </RadioGroup>
                      )}
                      name="Gender"
                      control={control}
                    />
                  </Grid>
                  <Grid item xs={6} sm={3} md={3}>
                    <Controller
                      render={({ field }) => (
                        <RadioGroup row aria-label="MaritalStatus" {...field} value={String(watch('MaritalStatus') ?? '')}>
                          <FormControlLabel value="0" control={<Radio size="small" />} label={t('worker.single')} />
                          <FormControlLabel value="1" control={<Radio size="small" />} label={t('worker.married')} />
                        </RadioGroup>
                      )}
                      name="MaritalStatus"
                      control={control}
                    />
                  </Grid>
                </Grid>
              </Box>

              {/* Contact */}
              <Box sx={sectionSx(theme.palette.success.main)}>
                <Typography variant="subtitle2" sx={sectionTitleSx('success.dark')}>
                  <ContactMailIcon sx={{ fontSize: 18 }} /> Kontakti
                </Typography>
                <Grid container spacing={{ xs: 1, sm: 1.5 }}>
                  <Grid item xs={12} sm={6}>
                    <InputController placeholder="Email personal" error={errors.Email} control={control} register={{ ...register('Email') }} name="Email" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* Adresa që ia jep kompania — mbyllet me largimin, ndryshe nga ajo personale. */}
                    <InputController placeholder="Email i punës (kompanisë)" error={errors.WorkEmail} control={control} register={{ ...register('WorkEmail') }} name="WorkEmail" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputController placeholder="Telefoni" error={errors.Phone} control={control} register={{ ...register('Phone') }} name="Phone" />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <PreferredEmailPicker control={control} watch={watch} />
                  </Grid>
                </Grid>
              </Box>

              {/* Address */}
              <Box sx={sectionSx(theme.palette.warning.main)}>
                <Typography variant="subtitle2" sx={sectionTitleSx('warning.dark')}>
                  <LocationOnIcon sx={{ fontSize: 18 }} /> Adresa
                </Typography>
                <Grid container spacing={{ xs: 1, sm: 1.5 }}>
                  <Grid item xs={12}>
                    <InputController placeholder="Adresa" error={errors.Address} control={control} register={{ ...register('Address') }} name="Address" />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputController placeholder="Qyteti" error={errors.Place} control={control} register={{ ...register('Place') }} name="Place" />
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <InputController placeholder="Kodi Postal" error={errors.PostalCode} control={control} register={{ ...register('PostalCode') }} name="PostalCode" />
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <InputController placeholder="Shteti" error={errors.Country} control={control} register={{ ...register('Country') }} name="Country" />
                  </Grid>
                </Grid>
              </Box>

              {/* Bank */}
              <Box sx={sectionSx(theme.palette.info.main)}>
                <Typography variant="subtitle2" sx={sectionTitleSx('info.dark')}>
                  <AccountBalanceRoundedIcon sx={{ fontSize: 18 }} /> Banka
                </Typography>
                <Grid container spacing={{ xs: 1, sm: 1.5 }}>
                  <Grid item xs={12}>
                    {/* Historik llogarish: e vjetra s'fshihet, çaktivizohet. Forma
                        s'e prek më xhirollogarinë — pasqyra ndjek llogarinë aktive. */}
                    <WorkerBankAccounts
                      workerId={id}
                      onActiveChange={(acc) => {
                        setValue('BankAccount', acc?.AccountNumber || '');
                        setValue('BankName', acc?.BankName || '');
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* Nëse paga është dakorduar neto, lista e pagave e nxjerr
                        bruton mbrapsht nga ajo shumë — pa këtë, punëtori me
                        "500 neto" do të merrte 500 bruto, pra rreth 420 në dorë. */}
                    <Controller
                      name="SalaryType"
                      control={control}
                      render={({ field }) => (
                        <FormControl fullWidth size="small">
                          <InputLabel>Paga dakorduar</InputLabel>
                          <Select {...field} value={field.value || 'gross'} label="Paga dakorduar">
                            <MenuItem value="gross">Bruto</MenuItem>
                            <MenuItem value="net">Neto</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* Rezidenca prek përllogaritjen e pagës, ndaj rri pranë saj
                        e jo te të dhënat personale. */}
                    <Controller
                      name="Residency"
                      control={control}
                      render={({ field }) => (
                        <FormControl fullWidth size="small">
                          <InputLabel>Rezidenca</InputLabel>
                          <Select {...field} value={field.value || 'resident'} label="Rezidenca">
                            <MenuItem value="resident">Vendas</MenuItem>
                            <MenuItem value="foreign">Punëtor i huaj</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    {/* Nuk është vetëm shënim: te lista e pagave, punësimi i dytë
                        tatohet pa brezin e liruar — brezat i zbaton punëdhënësi
                        primar. Pra e njëjta pagë bruto jep tatim tjetër. */}
                    <FormControlLabel
                      control={(
                        <MuiSwitch
                          checked={watch('SecondJob') === true}
                          onChange={(_, v) => setValue('SecondJob', v)}
                        />
                      )}
                      label={(
                        <Typography variant="caption">
                          {watch('SecondJob') === true ? 'Punësim sekondar' : 'Punësim primar'}
                          <Typography component="span" variant="caption" sx={{ color: 'text.secondary', display: 'block', lineHeight: 1.2 }}>
                            {watch('SecondJob') === true
                              ? 'tatohet pa brezin e liruar'
                              : 'brezat tatimorë zbatohen normalisht'}
                          </Typography>
                        </Typography>
                      )}
                    />
                  </Grid>
                </Grid>
              </Box>

              {/* Social networks */}
              <Box sx={sectionSx(theme.palette.secondary.main)}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: socialNetworks.length ? 1.5 : 0.5, gap: 1 }}>
                  <Typography variant="subtitle2" sx={{ ...sectionTitleSx('secondary.dark'), mb: 0 }}>
                    <ShareIcon sx={{ fontSize: 18 }} /> {t('worker.socialNetworks')}
                  </Typography>
                  <Button size="small" variant="outlined" color="secondary" startIcon={<AddIcon />} onClick={addSocialNetwork} sx={{ textTransform: 'none', borderRadius: 1.5 }}>
                    {t('worker.addSocialNetwork')}
                  </Button>
                </Box>
                {socialNetworks.length > 0 && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    {socialNetworks.map((sn, idx) => {
                      const platform = socialPlatforms.find((p) => p.id === sn.platform) || socialPlatforms[0];
                      return (
                        <Box key={`${sn.platform}-${idx}`} sx={{ display: 'flex', alignItems: 'center', gap: 1, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: 1.5, p: 0.75 }}>
                          <FormControl size="small" sx={{ minWidth: { xs: 150, sm: 200 } }}>
                            <Select
                              value={sn.platform}
                              onChange={(e) => updateSocialNetwork(idx, 'platform', e.target.value)}
                              renderValue={(val) => {
                                const p = socialPlatforms.find((x) => x.id === val) || socialPlatforms[0];
                                const Ic = p.Icon;
                                return (<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}><Ic sx={{ fontSize: 18, color: p.color }} /><span>{t(p.labelKey)}</span></Box>);
                              }}
                              sx={{ borderRadius: 1.5, bgcolor: 'white' }}
                            >
                              {socialPlatforms.map((p) => {
                                const Ic = p.Icon;
                                return (
                                  <MenuItem key={p.id} value={p.id}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, width: '100%' }}>
                                      <Ic sx={{ fontSize: 18, color: p.color }} /><span>{t(p.labelKey)}</span>
                                      {p.notify && (<Chip label={t('worker.socialNotifyHint')} size="small" sx={{ ml: 'auto', height: 18, fontSize: '0.65rem', bgcolor: alpha(theme.palette.success.main, 0.12), color: 'success.dark', '& .MuiChip-label': { px: 0.75 } }} />)}
                                    </Box>
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                          <TextField size="small" fullWidth value={sn.value} onChange={(e) => updateSocialNetwork(idx, 'value', e.target.value)} placeholder={platform.placeholder} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, bgcolor: 'white' } }} />
                          <Tooltip title={t('worker.socialRemove')}>
                            <IconButton size="small" onClick={() => removeSocialNetwork(idx)} sx={{ color: 'error.main' }}><CloseIcon sx={{ fontSize: 18 }} /></IconButton>
                          </Tooltip>
                        </Box>
                      );
                    })}
                  </Box>
                )}
              </Box>
              </Box>{/* end Tab 0 */}

              {/* ── Tab 1: Punësimi & Kontrata ─────────────────────────────────── */}
              <Box sx={{ display: tab === 1 ? 'block' : 'none' }}>
              {/* Employment (023) */}
              <Box sx={{ mb: 1.25, p: { xs: 1.25, sm: 1.5 }, borderRadius: 2, bgcolor: '#EFF6FF', border: '1px solid #BFDBFE' }}>
                <Typography variant="subtitle2" sx={{ ...sectionTitleSx('#1D4ED8') }}>
                  <BusinessCenterIcon sx={{ fontSize: 16 }} /> {t('worker.employmentDetails')}
                </Typography>
                <Grid container spacing={{ xs: 1, sm: 1.5 }}>
                  <Grid item xs={12} sm={6} md={4}>
                    <InputController placeholder={t('worker.position')} control={control} register={{ ...register('Position') }} name="Position" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <InputController placeholder={t('worker.employmentStartDate')} control={control} type="date" register={{ ...register('StartDate') }} name="StartDate" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <InputController placeholder={t('worker.employmentEndDate')} control={control} type="date" register={{ ...register('EmploymentEndDate') }} name="EmploymentEndDate" />
                  </Grid>
                  {/* ── Data e aktivizimit ──────────────────────────────────
                      Punëtori ekziston në HR, kontratë dhe planifikim që tani;
                      llogaria e tij hyn vetëm nga kjo datë. Serveri e krahason
                      në çdo hyrje dhe çdo kërkesë — jo ndonjë job — ndaj një
                      datë e ndryshuar këtu vlen sapo ruhet, edhe për një sesion
                      të hapur. Bosh = qasje menjëherë, si më parë. */}
                  <Grid item xs={12} sm={6} md={4}>
                    <InputController placeholder={t('worker.activationDate', 'Data e aktivizimit')} control={control} type="date" register={{ ...register('ActivationDate') }} name="ActivationDate" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={8}>
                    <ActivationDateHint value={watch('ActivationDate')} hasAccount={!!linkedAccount} />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Controller
                      name="SupervisorId"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          options={allWorkers}
                          getOptionLabel={(o) => o ? `${o.FirstName || o.first_name || ''} ${o.LastName || o.last_name || ''}`.trim() : ''}
                          value={allWorkers.find(w => (w.Id || w.id) === field.value) || null}
                          onChange={(_, v) => field.onChange(v ? (v.Id || v.id) : null)}
                          isOptionEqualToValue={(o, v) => (o?.Id || o?.id) === (v?.Id || v?.id)}
                          size="small"
                          renderInput={(params) => (
                            <TextField {...params} label={t('worker.supervisor')} size="small" fullWidth />
                          )}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Controller
                      name="Branch"
                      control={control}
                      render={({ field }) => (
                        <Autocomplete
                          options={allBranches}
                          getOptionLabel={(o) => o?.Name || o?.name || ''}
                          value={allBranches.find((b) => String(b.Id ?? b.id) === String(field.value)) || null}
                          onChange={(_, v) => field.onChange(v ? (v.Id ?? v.id) : null)}
                          isOptionEqualToValue={(o, v) => String(o?.Id ?? o?.id) === String(v?.Id ?? v?.id)}
                          size="small"
                          renderInput={(params) => (
                            <TextField {...params} label={t('worker.branch', 'Filiali')} size="small" fullWidth />
                          )}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Controller
                      name="DepartmentIds"
                      control={control}
                      render={({ field }) => {
                        const val = Array.isArray(field.value) ? field.value : [];
                        const selected = allDepartments.filter(d => val.includes(d.Id || d.id));
                        return (
                          <Autocomplete
                            multiple
                            // Departamentet e filialit të zgjedhur (një departament mund të jetë në disa).
                            options={departmentsForBranch(allDepartments, watch('Branch'))}
                            getOptionLabel={(o) => o?.Name || o?.name || ''}
                            value={selected}
                            onChange={(_, v) => field.onChange(v.map(d => d.Id || d.id))}
                            isOptionEqualToValue={(o, v) => (o?.Id || o?.id) === (v?.Id || v?.id)}
                            size="small"
                            renderTags={(vals, getTagProps) =>
                              vals.map((opt, idx) => (
                                <Chip label={opt?.Name || opt?.name || ''} size="small" {...getTagProps({ index: idx })} key={opt?.Id || opt?.id} />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField {...params} label={t('worker.departments')} size="small" fullWidth />
                            )}
                          />
                        );
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Controller
                      name="ProjectIds"
                      control={control}
                      render={({ field }) => {
                        const val = Array.isArray(field.value) ? field.value : [];
                        const selected = allProjects.filter(p => val.includes(p.Id || p.id));
                        return (
                          <Autocomplete
                            multiple
                            options={allProjects}
                            getOptionLabel={(o) => o?.Name || o?.name || ''}
                            value={selected}
                            onChange={(_, v) => field.onChange(v.map(p => p.Id || p.id))}
                            isOptionEqualToValue={(o, v) => (o?.Id || o?.id) === (v?.Id || v?.id)}
                            size="small"
                            renderTags={(vals, getTagProps) =>
                              vals.map((opt, idx) => (
                                <Chip label={opt?.Name || opt?.name || ''} size="small" {...getTagProps({ index: idx })} key={opt?.Id || opt?.id} />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField {...params} label={t('worker.projects')} size="small" fullWidth />
                            )}
                          />
                        );
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Controller
                      name="SeparationType"
                      control={control}
                      render={({ field }) => (
                        <FormControl fullWidth size="small">
                          <InputLabel>{t('worker.separationType')}</InputLabel>
                          <Select {...field} value={field.value || ''} label={t('worker.separationType')}>
                            <MenuItem value="">{t('common.none')}</MenuItem>
                            <MenuItem value="resigned">{t('worker.separationResigned')}</MenuItem>
                            <MenuItem value="terminated">{t('worker.separationTerminated')}</MenuItem>
                          </Select>
                        </FormControl>
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={8}>
                    <Controller
                      name="SeparationReason"
                      control={control}
                      render={({ field }) => (
                        <TextField {...field} value={field.value || ''} label={t('worker.separationReason')} size="small" fullWidth multiline minRows={1} maxRows={3} />
                      )}
                    />
                  </Grid>

                  {/* ── Regjistrimi i Prezencës ─────────────────────────────
                      Blloku jeton te `AttendanceAccess` — një kopje për tërë
                      aplikacionin, e përbashkët me ekranin e regjistrimit.
                      Këtu ishte i shkruar me dorë me pesë `Controller`-a të
                      mbivendosur; forma ishte e njëjta, por çdo rregullim
                      duhej bërë dy herë dhe njëra kopje mbetej gjithmonë pas.

                      Hierarkia mbetet ajo e vërteta:
                        e drejta   → `AttendanceEnabled`  (çelësi kryesor)
                        kanalet    → `AttendanceChannels` (ku lejohet)
                        hollësitë  → `KioskScanAllowed` / `HasTimeTracker`,
                                     të varura nën kanalin që prekin.

                      Të katër fushat ruhen saktësisht si më parë; `setValue`
                      me `shouldDirty` që butoni «Ruaj» ta shohë ndryshimin. */}
                  <Grid item xs={12}>
                    <AttendanceAccess
                      canManage={canManageAttendance}
                      value={{
                        enabled:          watch('AttendanceEnabled') !== false,
                        channels:         watch('AttendanceChannels') ?? null,
                        kioskScanAllowed: watch('KioskScanAllowed') !== false,
                        kioskScanNote:    watch('KioskScanNote') || '',
                        hasTimeTracker:   watch('HasTimeTracker') !== false,
                      }}
                      onChange={(patch) => {
                        const FIELD = {
                          enabled: 'AttendanceEnabled', channels: 'AttendanceChannels',
                          kioskScanAllowed: 'KioskScanAllowed', kioskScanNote: 'KioskScanNote',
                          hasTimeTracker: 'HasTimeTracker',
                        };
                        for (const [k, v] of Object.entries(patch)) {
                          if (FIELD[k]) setValue(FIELD[k], v, { shouldDirty: true });
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>

              {/* Contracts — e njëjta vendndodhje si «Kontrata» te regjistrimi */}
              <Box sx={sectionSx(theme.palette.info.main)}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, mb: 1 }}>
                  <Typography variant="subtitle2" sx={{ ...sectionTitleSx('info.dark'), mb: 0 }}>
                    <DescriptionRoundedIcon sx={{ fontSize: 18 }} /> {t('worker.contracts')}
                    {contracts.length > 0 && <Chip label={contracts.length} size="small" sx={{ height: 18, fontSize: '0.65rem', ml: 0.5 }} />}
                  </Typography>
                  <Button component={Link} to={`/workerlist/addworkercontract/${id}`} size="small" variant="outlined" color="info" startIcon={<AddIcon />} sx={{ textTransform: 'none', borderRadius: 1.5 }}>
                    Shto kontratë
                  </Button>
                </Box>
                {loaderContracts && <LinearProgress sx={{ my: 2 }} />}
                {!loaderContracts && <>
                  <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 1.5 }}>
                    <Table sx={{ minWidth: 700 }} size="small" aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Nr</TableCell>
                          <TableCell>{t('worker.startDate')}</TableCell>
                          <TableCell>{t('worker.endDate')}</TableCell>
                          <TableCell>{t('worker.salary')}</TableCell>
                          <TableCell>{t('worker.hourlyRate')}</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {contracts.length === 0 && (
                          <TableRow>
                            <TableCell colSpan={6}>
                              <Typography variant="caption" sx={{ color: 'text.secondary' }}>Punëtori nuk ka ende kontratë.</Typography>
                            </TableCell>
                          </TableRow>
                        )}
                        {contracts
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((w, index) => (
                            <TableRow key={w.Id}>
                              <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                              <TableCell>{dateFormats(w.StartDate)}</TableCell>
                              <TableCell>{dateFormats(w.EndDate)}</TableCell>
                              <TableCell>{w.BaseSalary ?? w.Salary ?? '—'}</TableCell>
                              <TableCell>{w.HourSalary ?? '—'}</TableCell>
                              <TableCell>
                                <ButtonGroup size="small">
                                  <Link to={`/workerlist/editworkercontract/${w.Id}`}>
                                    <Button>
                                      <EditIcon />
                                    </Button>
                                  </Link>
                                  <Button onClick={() => openModal(w.Id)}>
                                    <DeleteIcon />
                                  </Button>
                                </ButtonGroup>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {contracts.length > 10 && (
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 100]}
                      component="div"
                      count={contracts.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  )}
                </>}
              </Box>

              {/* Projects — «Cakto punëtorin në projekt» te regjistrimi */}
              <Box sx={sectionSx(theme.palette.secondary.main)}>
                <Typography variant="subtitle2" sx={sectionTitleSx('secondary.dark')}>
                  <BusinessCenterIcon sx={{ fontSize: 18 }} /> Cakto punëtorin në projekt
                </Typography>
                <WorkerProjectAssignmentForm
                  defaultWorkerId={id}
                  hideWorkerSelect
                  onSaved={() => setProjectHistoryKey(k => k + 1)}
                />
                <WorkerProjectHistory key={projectHistoryKey} workerId={id} />
              </Box>

              {/* Leave history — HolidaysHistory shfaqet vetëm kur ka rreshta */}
              <HolidaysHistory id={id} />

              {/* Consent history */}
              {workerConsents.length > 0 && (
                <Box sx={{ ...sectionSx(theme.palette.warning.main), mt: 1.25 }}>
                  <Typography variant="subtitle2" sx={sectionTitleSx('warning.dark')}>
                    <VerifiedUserRoundedIcon sx={{ fontSize: 18 }} /> {t('worker.consentHistoryTitle')}
                  </Typography>
                  <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 1.5 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>{t('worker.consentTableCompany')}</TableCell>
                          <TableCell>{t('worker.consentTableTermDate')}</TableCell>
                          <TableCell>{t('worker.consentTableReason')}</TableCell>
                          <TableCell>{t('worker.consentTableStatus')}</TableCell>
                          <TableCell>{t('worker.consentTableComment')}</TableCell>
                          <TableCell>{t('worker.consentTableResponded')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {workerConsents.map((c) => {
                          const statusCfg =
                            c.status === 'agreed'
                              ? { label: `✓ ${t('worker.consent.agreed')}`, bg: '#f0fdf4', color: '#166534' }
                              : c.status === 'disagreed'
                              ? { label: `✗ ${t('worker.consent.disagreed')}`, bg: '#fef2f2', color: '#991b1b' }
                              : { label: `⏳ ${t('worker.consent.pending')}`, bg: '#fffbeb', color: '#92400e' };
                          return (
                            <TableRow key={c.id}>
                              <TableCell>{c.companyName || '—'}</TableCell>
                              <TableCell>{c.termDate ? dateFormats(c.termDate) : '—'}</TableCell>
                              <TableCell>{c.reason || '—'}</TableCell>
                              <TableCell>
                                <span style={{ padding: '2px 8px', borderRadius: 999, fontWeight: 700, fontSize: '0.75rem', background: statusCfg.bg, color: statusCfg.color }}>
                                  {statusCfg.label}
                                </span>
                              </TableCell>
                              <TableCell>{c.comment || '—'}</TableCell>
                              <TableCell>{c.respondedAt ? dateFormats(c.respondedAt) : '—'}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              )}
              </Box>{/* end Tab 1 */}

              {/* ── Tab 2: Dokumente & Qasje ───────────────────────────────────── */}
              <Box sx={{ display: tab === 2 ? 'block' : 'none' }}>
              {/* ATK Registration */}
              <Box sx={sectionSx(theme.palette.info.main)}>
                <Typography variant="subtitle2" sx={sectionTitleSx('info.dark')}>
                  <BadgeRoundedIcon sx={{ fontSize: 18 }} /> {t('worker.atkSection')}
                </Typography>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={1.5} alignItems={{ xs: 'stretch', md: 'center' }} useFlexGap flexWrap="wrap">
                  <Box sx={{ minWidth: { xs: '100%', md: 220 } }}>
                    <InputController
                      placeholder={t('worker.atkRegistrationDate')}
                      error={errors.ATKRegisteredAt}
                      control={control}
                      type="date"
                      register={{ ...register('ATKRegisteredAt') }}
                      name="ATKRegisteredAt"
                    />
                  </Box>
                  <Controller
                    name="ATKRegistered"
                    control={control}
                    render={({ field }) => (
                      <FormControlLabel
                        control={
                          <MuiSwitch
                            size="small"
                            checked={!!watch('ATKRegistered')}
                            onChange={async (e) => {
                              // `checked` lexohet PARA `await`-it: pas tij ngjarja
                              // mund të jetë rikthyer dhe `e.target` s'është më ai.
                              const checked = e.target.checked;
                              if (checked) {
                                const ok = await confirm({
                                  title: 'Regjistrimi në ATK',
                                  message: t('worker.confirmATKRegistration'),
                                  confirmLabel: 'Po, regjistroje',
                                  color: 'primary',
                                });
                                if (!ok) return;
                                if (!watch('ATKRegisteredAt')) setValue('ATKRegisteredAt', todayYMD());
                              }
                              field.onChange(checked);
                            }}
                          />
                        }
                        label={t('worker.atkConfirmed')}
                        sx={{ m: 0 }}
                      />
                    )}
                  />
                  <Box sx={{ flex: 1 }} />
                  <Stack direction="row" spacing={1}>
                    <Button variant="outlined" size="small" onClick={() => setValue('ATKRegisteredAt', todayYMD())}>{t('worker.markRegisteredToday')}</Button>
                    <Button component={Link} to="/home/reports/atk-tm" variant="outlined" size="small">{t('worker.openATKReports')}</Button>
                  </Stack>
                </Stack>
              </Box>

              {/* Health insurance */}
              <Box sx={{ ...sectionSx(theme.palette.warning.main), '& .MuiInputBase-input': { py: '7px', fontSize: '0.85rem' }, '& .MuiInputLabel-root': { fontSize: '0.82rem' } }}>
                <Typography variant="subtitle2" sx={sectionTitleSx('warning.dark')}>
                  <MedicalServicesOutlinedIcon sx={{ fontSize: 18 }} /> {t('worker.healthInsuranceTitle')}
                  <Chip size="small" label={t('worker.healthInsuranceNote')} sx={{ height: 20, fontSize: '0.68rem', bgcolor: '#FEF3C7', color: '#78350F', borderRadius: 1, ml: 0.5 }} />
                  {expiryChip(watch('HealthInsExpires'))}
                </Typography>

                {/* Total budget — split across worker + family, capped at this amount */}
                <Grid container spacing={{ xs: 1, sm: 1.5 }} alignItems="center" sx={{ mb: 1.25 }}>
                  <Grid item xs={12} sm={4}>
                    <InputController placeholder="Shuma totale e sigurimit" control={control} type="number" symbol="€" register={{ ...register('HealthInsTotal') }} name="HealthInsTotal" />
                  </Grid>
                  {insTotal > 0 && (
                    <Grid item xs={12} sm={8}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                        <Chip size="small" label={`E ndarë: ${insAllocated.toFixed(2)} €`} sx={{ height: 22, fontWeight: 700, bgcolor: alpha(theme.palette.warning.main, 0.12), color: 'warning.dark' }} />
                        <Chip size="small" label={`E mbetur: ${insRemaining.toFixed(2)} €`} sx={{ height: 22, fontWeight: 700, bgcolor: insOver ? alpha(theme.palette.error.main, 0.15) : alpha(theme.palette.success.main, 0.14), color: insOver ? 'error.main' : 'success.dark' }} />
                        {insOver && <Typography variant="caption" sx={{ color: 'error.main', fontWeight: 700 }}>Ndarja tejkalon totalin!</Typography>}
                      </Box>
                    </Grid>
                  )}
                </Grid>

                {/* Primary insured card */}
                <Box sx={{ bgcolor: 'white', border: '1px solid', borderColor: 'divider', borderRadius: 1.5, px: 1, py: 0.75, mb: 0.75 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography variant="caption" sx={{ fontWeight: 700, color: 'warning.dark' }}>I siguruari kryesor (punëtori)</Typography>
                    {insBase > 0 && (
                      <Chip size="small" label={`${insPct(insMainAmount)}%`} sx={{ height: 20, fontSize: '0.65rem', fontWeight: 700, bgcolor: alpha(theme.palette.warning.main, 0.15), color: 'warning.dark' }} />
                    )}
                  </Box>
                  <Grid container spacing={{ xs: 1, sm: 1.5 }}>
                    <Grid item xs={12} sm={3}>
                      <InputController placeholder="Numri i kartelës" control={control} register={{ ...register('HealthInsNumber') }} name="HealthInsNumber" />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <InputController placeholder="Emri i të siguruarit" control={control} register={{ ...register('HealthInsHolderName') }} name="HealthInsHolderName" />
                    </Grid>
                    <Grid item xs={6} sm={2}>
                      <InputController placeholder="Data e fillimit" control={control} type="date" register={{ ...register('HealthInsIssued') }} name="HealthInsIssued" />
                    </Grid>
                    <Grid item xs={6} sm={2}>
                      <InputController placeholder="Data e përfundimit" control={control} type="date" register={{ ...register('HealthInsExpires') }} name="HealthInsExpires" />
                    </Grid>
                    <Grid item xs={6} sm={2}>
                      <InputController placeholder="Shuma" control={control} type="number" symbol="€" register={{ ...register('HealthInsPersonal') }} name="HealthInsPersonal" changeHandler={(e) => setPrimaryAmount(e?.target?.value)} />
                    </Grid>
                  </Grid>
                </Box>

                {/* Family members */}
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: insMembers.length ? 1 : 0, gap: 1 }}>
                  <Typography variant="caption" sx={{ fontWeight: 700, color: 'warning.dark', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <PersonIcon sx={{ fontSize: 15 }} /> Sigurimi për familjarë
                    {insMembers.length > 0 && <Chip label={insMembers.length} size="small" sx={{ height: 18, fontSize: '0.65rem', ml: 0.5 }} />}
                  </Typography>
                  <Button size="small" variant="outlined" color="warning" startIcon={<AddIcon />} onClick={addInsMember} sx={{ textTransform: 'none', borderRadius: 1.5 }}>
                    Shto familjar
                  </Button>
                </Box>
                {insMembers.length > 0 && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                    {insMembers.map((m, idx) => (
                      <Box key={idx} sx={{ bgcolor: 'white', border: '1px solid', borderColor: 'divider', borderRadius: 1.5, px: 1, py: 0.75 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                          <Typography variant="caption" sx={{ fontWeight: 700, color: 'warning.dark', display: 'flex', alignItems: 'center', gap: 0.4 }}>
                            <PersonIcon sx={{ fontSize: 13 }} /> Familjar {idx + 1}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            {insBase > 0 && <Chip size="small" label={`${insPct(m.amount)}%`} sx={{ height: 17, fontSize: '0.58rem', fontWeight: 700, bgcolor: alpha(theme.palette.warning.main, 0.15), color: 'warning.dark' }} />}
                            <IconButton size="small" onClick={() => removeInsMember(idx)} sx={{ color: 'error.main', p: 0.25 }}><CloseIcon sx={{ fontSize: 16 }} /></IconButton>
                          </Box>
                        </Box>
                        <Grid container spacing={1}>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <TextField size="small" fullWidth label="Emri i të siguruarit" value={m.name} onChange={(e) => updateInsMember(idx, 'name', e.target.value)} />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <FormControl size="small" fullWidth>
                              <InputLabel>Lidhja familjare</InputLabel>
                              <Select value={m.relation} label="Lidhja familjare" onChange={(e) => updateInsMember(idx, 'relation', e.target.value)}>
                                <MenuItem value="spouse">Bashkëshort/e</MenuItem>
                                <MenuItem value="child">Fëmijë</MenuItem>
                                <MenuItem value="parent">Prind</MenuItem>
                                <MenuItem value="sibling">Vëlla/Motër</MenuItem>
                                <MenuItem value="other">Tjetër</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <TextField size="small" fullWidth label="Nr. kartelës" value={m.cardNumber} onChange={(e) => updateInsMember(idx, 'cardNumber', e.target.value)} />
                          </Grid>
                          <Grid item xs={6} sm={6} md={4} lg={2}>
                            <TextField size="small" fullWidth type="date" label="Data e fillimit" InputLabelProps={{ shrink: true }} value={m.startDate} onChange={(e) => updateInsMember(idx, 'startDate', e.target.value)} />
                          </Grid>
                          <Grid item xs={6} sm={6} md={4} lg={2}>
                            <TextField size="small" fullWidth type="date" label="Data e përfundimit" InputLabelProps={{ shrink: true }} value={m.endDate} onChange={(e) => updateInsMember(idx, 'endDate', e.target.value)} />
                          </Grid>
                          <Grid item xs={12} sm={6} md={4} lg={2}>
                            <TextField size="small" fullWidth type="number" label="Shuma" value={m.amount} onChange={(e) => setMemberAmount(idx, e.target.value)} InputProps={{ endAdornment: <InputAdornment position="end">€</InputAdornment> }} />
                          </Grid>
                        </Grid>
                      </Box>
                    ))}
                  </Box>
                )}

                {/* Split summary */}
                {insBase > 0 && (
                  <Box sx={{ mt: 1.25, p: 1, borderRadius: 1.5, bgcolor: alpha(theme.palette.warning.main, 0.12), display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                    <Typography variant="caption" sx={{ fontWeight: 700, color: 'warning.dark' }}>
                      {insTotal > 0 ? `Totali: ${insTotal.toFixed(2)} € · E ndarë: ${insAllocated.toFixed(2)} €` : `Totali i sigurimit: ${insAllocated.toFixed(2)} €`}
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                      Punëtori {insPct(insMainAmount)}%{insMembers.length ? ` · Familjarë ${insPct(insMembersTotal)}%` : ''}
                    </Typography>
                  </Box>
                )}
              </Box>

              {/* Work permit */}
              <Box sx={sectionSx(theme.palette.success.main)}>
                <Typography variant="subtitle2" sx={sectionTitleSx('success.dark')}>
                  <VerifiedUserRoundedIcon sx={{ fontSize: 18 }} /> {t('worker.workPermit')}
                  {expiryChip(watch('WorkPermitExpires'))}
                </Typography>
                <Grid container spacing={{ xs: 1, sm: 1.5 }}>
                  <Grid item xs={12} sm={4}>
                    <InputController placeholder={t('worker.workPermitNumber')} error={errors.WorkPermitNumber} control={control} register={{ ...register('WorkPermitNumber') }} name="WorkPermitNumber" />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputController placeholder={t('worker.issuanceDate')} control={control} type="date" register={{ ...register('WorkPermitIssued') }} name="WorkPermitIssued" />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputController placeholder={t('worker.expiryDate')} control={control} type="date" register={{ ...register('WorkPermitExpires') }} name="WorkPermitExpires" />
                  </Grid>
                </Grid>
              </Box>

              {/* System access — llogaria e lidhur dhe statusi i saj (vetëm lexim) */}
              <Box sx={sectionSx(theme.palette.primary.main)}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1, flexWrap: 'wrap' }}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, minWidth: 0 }}>
                    <Box sx={{ width: 32, height: 32, borderRadius: 1.5, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: alpha(theme.palette.primary.main, 0.12), color: 'primary.dark', mt: 0.25 }}>
                      <SecurityRoundedIcon sx={{ fontSize: 18 }} />
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: { xs: '0.875rem', md: '0.9375rem' }, color: 'primary.dark', lineHeight: 1.25 }}>
                        {t('worker.systemAccess', 'Qasja në sistem')}
                      </Typography>
                      <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', mt: 0.25, lineHeight: 1.45 }}>
                        {linkedAccount === undefined && 'Duke kërkuar llogarinë e lidhur…'}
                        {linkedAccount === null && 'Punëtori nuk ka llogari hyrjeje. Krijohet te «Menaxhimi i përdoruesve» me email-in e kontaktit; data e aktivizimit vlen që nga krijimi.'}
                        {linkedAccount && (
                          <>
                            {linkedAccount.email}
                            {linkedAccount.role ? ` · roli: ${linkedAccount.role}` : ''}
                            {accountStatus(linkedAccount) === 'pending_activation'
                              ? ` · hyrja hapet më ${formatDMY(linkedAccount.activationDate || watch('ActivationDate'))}`
                              : linkedAccount.active === false ? ' · llogaria është çaktivizuar' : ' · ka qasje sipas privilegjeve'}
                            {/* Ftesa: e planifikuar (një ditë pune para fillimit) ose e dërguar. */}
                            {linkedAccount.inviteDueAt && !linkedAccount.inviteSentAt && ` · ftesa dërgohet më ${new Date(linkedAccount.inviteDueAt).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}`}
                            {linkedAccount.inviteSentAt && ` · ftesa u dërgua më ${new Date(linkedAccount.inviteSentAt).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}`}
                          </>
                        )}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
                    {linkedAccount && (() => { const st = accountStatusChip(linkedAccount); return (
                      <Chip size="small" label={st.label} color={st.color} variant={st.variant} sx={{ height: 24, fontWeight: 700 }} />
                    ); })()}
                    {linkedAccount === null && (
                      <Chip size="small" label="Pa llogari" variant="outlined" sx={{ height: 24, fontWeight: 700 }} />
                    )}
                    <Button component={Link} to="/user-management" size="small" variant="outlined" sx={{ textTransform: 'none', borderRadius: 1.5 }}>
                      Menaxho llogarinë
                    </Button>
                  </Box>
                </Box>
              </Box>

              {/* Custom Fields from Module Management */}
              <ModuleCustomFields
                ref={cfRef}
                moduleKey="workers"
                recordId={id}
                mode="edit"
                values={customValues}
                onChange={setCustomValues}
              />
              </Box>{/* end Tab 2 */}

              {/* Save row — always visible under the tabs */}
              <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  {[0, 1, 2].map((i) => (
                    <Box key={i} onClick={() => setTab(i)} sx={{ width: 8, height: 8, borderRadius: '50%', cursor: 'pointer', bgcolor: tab === i ? 'primary.main' : 'action.disabled' }} />
                  ))}
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  {tab < 2 && (
                    <Button variant="outlined" onClick={() => setTab((v) => Math.min(2, v + 1))}>
                      Vazhdo
                    </Button>
                  )}
                  <Button variant="contained" color="success" startIcon={<SaveIcon />} onClick={submit}>
                    Ruaj ndryshimet
                  </Button>
                </Box>
              </Box>
            </>}
          </Paper>
        </form>
      </Fragment>
    </Box>
  );
}
